(function (jQuery) {
	"use strict";

	function Main() {
		var global = {};

		var fn = {
			init: function () {
				jQuery(".no-js").removeClass("no-js");

				jQuery("main").fitVids({
					customSelector:
						'iframe[data-src*="youtube.com"], iframe[data-src*="youtube-nocookie.com"]',
				});

				fn.setUpGravityFormsLabels();
				fn.targetGravityFormsSelectLabels();
				fn.targetGFormsCountrySelectLabels();
				jQuery(".js-open-form").on("click", fn.openForm);
				jQuery(".js-slide-toggle").on("click", fn.toggleForm);
				jQuery(".gravity-form").hide();
				jQuery(".gfield .ginput_address_country select").change(
					fn.displayGFormsCountrySelectLabel
				);
			},

			setUpGravityFormsLabels: function () {
				if (!jQuery(".gravity-form").length) {
					return;
				}

				jQuery(fn.handleGravityFormsLabels);
				jQuery(window).bind("pageshow", fn.handleGravityFormsLabels); // handle labels if browser back button is used
				jQuery(document).on(
					"gform_post_render",
					fn.handleGravityFormsLabels
				);
			},

			handleGravityFormsLabels: function () {
				var inputs = jQuery(
					'.gravity-form .gform_body textarea, .gravity-form .gform_body input:not([type="hidden"]):not([type="checkbox"]):not([type="radio"]):not([type="submit"])'
				);

				inputs.each(function (index, element) {
					if (jQuery(element).val()) {
						var liParent = jQuery(this).closest(
							".gfield, .ginput_complex span"
						);
						var label = jQuery(liParent).find("label");

						label.addClass("labelfocus");
					}
				});

				inputs.on("focusin focusout", fn.placeholderLabel);
			},

			placeholderLabel: function (e) {
				var liParent = jQuery(this).closest(
					".gfield, .ginput_complex span"
				);
				var label = jQuery(liParent).find("label");

				if (
					e.type == "focusin" &&
					!jQuery(label).hasClass("labelfocus")
				) {
					label.addClass("labelfocus");
				}

				if (e.type == "focusout" && !jQuery(this).val()) {
					label.removeClass("labelfocus");
				}
			},

			targetGravityFormsSelectLabels: function () {
				if (!jQuery(".gform_wrapper").length) {
					return;
				}

				var gFormselect = jQuery(
					".ginput_container_select select, .ginput_container_multiselect select"
				);
				var gFormSelectParent = gFormselect.closest(".gfield");

				gFormSelectParent.find("label").addClass("gf-select__label");
			},

			targetGFormsCountrySelectLabels: function () {
				if (!jQuery(".gform_wrapper").length) {
					return;
				}

				fn.displayGFormsCountrySelectLabel();
			},

			displayGFormsCountrySelectLabel: function () {
				var gFormCountrySelect = jQuery(
					".gfield .ginput_address_country select"
				);
				var gFormCountrySelectLabel = jQuery(
					".gfield .ginput_address_country label"
				);

				if (gFormCountrySelect.find(":selected").val()) {
					gFormCountrySelectLabel.css("display", "none");
				} else {
					gFormCountrySelectLabel.css("display", "block");
				}
			},

			openForm: function () {
				jQuery(".gravity-form").hide();
				let linkedFormId = jQuery(this).data("linked-form");
				let linkedForm = jQuery("[data-form=" + linkedFormId + "]");
				linkedForm.slideDown();
				jQuery("html, body").animate(
					{
						scrollTop: linkedForm.offset().top - 90, // Header height
					},
					1000
				);
			},

			toggleForm: function () {
				jQuery("html, body").animate(
					{
						scrollTop: 0,
					},
					600
				);
				jQuery(this).parent().slideToggle();
			},
		};

		jQuery(fn.init);
	}

	new Main();
})(jQuery);
